export function pxToRem(number, baseNumber = 16) {
  return `${number / baseNumber}rem`;
}
